<template>
  <v-app>
    <v-app-bar app light v-if="authenticated">
      <div class="d-flex align-center mr-2">
        <a :href="'//catalogs-parts.com/'+$i18n.locale+'/'">
          <img :src="require(`@/assets/logo.png`)" height="40px" width="51px" />
        </a>
      </div>
      <v-toolbar-title class="overflow-visible hidden-sm-and-down">CATALOGS-PARTS</v-toolbar-title>
      <v-tabs
          align-with-title

          icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab to="/">
          {{ $t("sites.title") }}
          <v-icon>mdi-web</v-icon>
        </v-tab>

        <v-tab @click="isShowSupportMessageWindow=!isShowSupportMessageWindow">
          {{ $t("support.title") }}
          <v-icon>mdi-lifebuoy</v-icon>
        </v-tab>
        <v-tab :href="docsURL">
          {{ $t("docs.title") }}
          <v-icon>mdi-book</v-icon>
        </v-tab>
      </v-tabs>
      <v-btn icon @click="logout" :title="$t('common.logout')" color="black">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <levam-support-window
        :borderRadius="`10px`"
        :ticketId="ticketId"
        :isVisible.sync="isShowSupportMessageWindow"
        :lang="$i18n.locale"
        :isDarkTheme="$vuetify.theme.dark"
        :backendURL="url"
    >
    </levam-support-window>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";

export default {
  name: "App",
  components: { LanguageSwitcher },
  data: () => ({
    ticketId: null,
    isShowSupportMessageWindow: false,
  }),
  created() {
    //console.log()
    if(this.$route.query && this.$route.query.lang){
      this.$i18n.locale = this.$route.query.lang;
    }
    let ticketId = window.location.href.split("show_support_ticket=")[1];
    if (parseInt(ticketId) > 0) {
      this.ticketId = parseInt(ticketId);
      this.isShowSupportMessageWindow = true;
    }
  },
  computed: {
    docsURL(){
      if(this.client_lang==='ru') {
        return process.env.VUE_APP_DOCS_URL
      } else {
        return process.env.VUE_APP_DOCS_URL_EN
      }

    },
    ...mapFields("auth", ["authenticated", "client_lang"]),
    url() {
      return process.env.VUE_APP_API_URL;
    },
  },
  watch:{
    client_lang() {
      this.$i18n.locale = this.client_lang;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        if (this.authenticated !== true) {
          this.$router.push({ name: "Auth" });
        }
      });
    },
  },
};
</script>
<style>
  .pointer{
    cursor: pointer;
  }

</style>